import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useSelector } from "react-redux";

import {PaymentElement, useStripe, useElements, AddressElement} from '@stripe/react-stripe-js';

import { Button, Loader } from '@mantine/core';

import getSymbolFromCurrency from 'currency-symbol-map'

import { useTranslation } from "react-i18next";

export default function Payment(props) {
  const { t } = useTranslation();

  const user = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [addressCompleted, setAddressCompleted] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);

  const processing = useRef(0);
  const timeoutRef = useRef(null);

  const stripe = useStripe();
  const elements = useElements();

  const tax_amount = Number(props.tax_amount || 0);
  const defaultAddressValues = { defaultValues: props.address ? props.address : { name: user?.name, address: {} } };

  useEffect(() => {
    if (processing.current < props.processing){
      setLoading(false);
    }
  }, [props])

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    await props.onPay(stripe, elements);
  }

  const getFrequency = () => {
    return props.frequency && props.frequency != "once" ? ` / ${props.frequency}` : "";
  }

  const buttonText = () => {
    let amount = props.amount ? parseFloat(props.amount) : 0
    amount = amount + tax_amount
    return `${t("spaces.stripe.pay")} ${getSymbolFromCurrency(props.currency)}${amount.toFixed(2).replace(".00", "")}${getFrequency()}`
  }

  const handleAddressChange = (event) => {
    if (event.complete && !addressCompleted) {
      setAddressCompleted(true);
      if (typeof props.onAddressChanged === "function") {
        props.onAddressChanged(event?.value);
      }
    } else if (addressCompleted) {
      setAddressCompleted(false);
    }
  };

  const handlePaymentChange = (event) => {
    if (event.complete && !addressCompleted) {
      setPaymentCompleted(true);
    } else if (paymentCompleted) {
      setPaymentCompleted(false);
    }
  };

  const debouncedOnChangeAddress = useCallback((event) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => handleAddressChange(event), 1000);
  }, []);

  const debouncedOnChangePayment = useCallback((event) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => handlePaymentChange(event), 1000);
  }, []);

  return (
    <form onSubmit={onSubmit}>
      {props.tax_collection && (
        <AddressElement
          options={{
            mode: 'shipping',
            fields: {
              phone: "never"
            },
            ...defaultAddressValues
          }}
          onChange={debouncedOnChangeAddress}
        />
      )}
      <PaymentElement onChange={debouncedOnChangePayment} />
      <Button
        fullWidth
        mt="xl"
        radius="xl"
        size="lg"
        mb={15}
        type="submit"
        disabled={loading || (!addressCompleted && props.tax_collection) || !paymentCompleted}
      >
        {loading ? <Loader /> : buttonText()}
      </Button>
    </form>
  )
}
